import { Box, Typography } from "@mui/material";
import OrderHistory from "@/app/components/order/OrderHistory";
import OrderHeaderFilters from "@/app/components/order/OrderHistoryHeaderFilters";
import { OrderHistoryFilterProvider } from "@/app/provider/OrderHistoryFilterProvider";
import OrderAdvancedFilters from "@/app/components/order/OrderAdvancedFilters";
import OrderHistorySortBy from "@/app/components/order/OrderHistorySortBy";
import { OrderHistoryTableProvider } from "@/app/provider/OrderHistoryTableProvider";
import { useSelector } from "react-redux";
import { RootState } from "@/app/store/store";
import Error404Page from "../errors/404";

const OrderHistoryPage = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.userState.isAuthenticated
  );

  if (!isAuthenticated) {
    return <Error404Page />;
  }

  return (
    <OrderHistoryFilterProvider>
      <OrderHistoryTableProvider>
        <Box
          sx={{
            backgroundColor: "#f8f8f8",
          }}
        >
          <Box className="page-title">
            <Typography variant="h1" textAlign={"center"}>
              My Orders
            </Typography>
          </Box>
          <OrderHeaderFilters />
          <OrderAdvancedFilters />
          <OrderHistorySortBy />
          <OrderHistory />
        </Box>
      </OrderHistoryTableProvider>
    </OrderHistoryFilterProvider>
  );
};

export default OrderHistoryPage;
